<template>
    <div id="poi-container">
        <div class="row no-gutters d-flex flex-column flex-lg-row align-items-center">
            <div class="col-auto d-flex flex-lg-column" id="themes-bar">
                <button class="btn btn-poi text-white d-flex flex-fill flex-column align-items-center justify-content-center font-b transition-bezier" 
                    @click="toggleFilter(1)"
                    :class="{'active': filters == 1 }">
                    <span>Transport</span>
                    <img src="/img/picto-transport.svg" loading="lazy" />
                </button>
                <button class="btn btn-poi text-white flex-fill d-flex flex-column align-items-center justify-content-center font-b transition-bezier" 
                    @click="toggleFilter(2)"
                    :class="{'active': filters == 2 }">
                    <span>Commerces <span class="d-block">& Services</span></span>
                    <img src="/img/picto-commerces.svg" loading="lazy" />
                </button>
                <button class="btn btn-poi text-white flex-fill d-flex flex-column align-items-center justify-content-center font-b transition-bezier" 
                    @click="toggleFilter(4)"
                    :class="{'active': filters == 4}">
                    <span>Education</span>
                    <img src="/img/picto-education.svg" loading="lazy" />
                </button>
                <button class="btn btn-poi text-white flex-fill d-flex flex-column align-items-center justify-content-center font-b transition-bezier" 
                    @click="toggleFilter(3)"
                    :class="{'active': filters == 3}">
                    <span>Sports<span class="d-block">& Loisirs</span></span>
                    <img src="/img/picto-sports.svg" loading="lazy" />
                </button>
            </div>
            <div class="col">
                <GmapMap
                  :center="{lat:lat, lng:lng}"
                  :zoom="zoom"
                  id="map" class="mx-auto bg-light-grey"
                  map-type-id="terrain"
                  ref="mapRef"
                  @center_changed="search"
                  @zoom_changed="search"
                >
                  <GmapMarker 
                    :position="{lat: lat, lng: lng}"
                    icon="/img/map-pin.svg"/>
                    
                  <GmapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :position="m.position"
                    :clickable="true"
                    :draggable="false"
                    :icon="m.icon"
                    @click="openInfoWindowTemplate(m)"
                  />
                  
                <gmap-info-window
                    :options="infoWindow.options"
                    :position="infoWindow.position"
                    :opened="infoWindow.open"
                    class="infowindow"
                    @closeclick="infoWindow.open=false">
                    <div v-html="infoWindow.template"></div>
                </gmap-info-window>
                
                </GmapMap>
            </div>
        </div>
        
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import * as GmapVue from 'gmap-vue'
import { gmapApi } from 'gmap-vue';

Vue.use(GmapVue, {
    load: {
        key: 'AIzaSyC9sCpjgcYXeR6WrVtOv5KudMqzeMtCUzE',
    },
    installComponents: true
});


export default {
    props: {
        apiKey: {
            type: String,
            required: false,
            default: false,
        },
        lat: {
            type: Number,
            required: true,
            default: false,
        },
        lng: {
            type: Number,
            required: true,
            default: false,
        },
        zoom: {
            type: Number,
            required: true,
            default: false,
        },
    },
    data: function () {
        return {
            markers: [],
            filters: 0,
            infoWindow: {
            position: {lat: 0, lng: 0},
            open: false,
            template: '',
            options: {
                maxWidth: 300,
                minHeight: 70,
                pixelOffset: {
                    width: 0,
                    height: -75
                }
            }
            }
        };
    },
    computed: {
        google: gmapApi,
    },
    methods: {
        toggleFilter: function(filter) {
            // if (this.filters.includes(filter)) {
            //     this.filters.splice(this.filters.indexOf(filter), 1);
            // } else {
            //     this.filters.push(filter);
            // }
            
            if(this.filters == filter) {
                this.filters = 0;
            }
            else {
                this.filters = filter;
            }
            
            this.markers = [];
            
            if(this.filters != 0) {
                this.search();
            }
        },
        getBounds: function() {
            let bounds = this.$refs.mapRef.$mapObject.getBounds();
            bounds = Object.entries(bounds)
            return {
                minLat: bounds[0][1].g,
                maxLat: bounds[0][1].i,
                minLng: bounds[1][1].g,
                maxLng: bounds[1][1].i
            };
        },
        updateCenter: function(latLng) {
          //console.log(this.getBounds())
        },
        openInfoWindowTemplate: function(item) {
            this.infoWindow.template = item.infos.cat + " " + item.infos.nom
            this.infoWindow.position = item.position
            this.infoWindow.open = true
       },
        search: function () {
            let self = this;
            
            axios
                .post('https://primarte.stay-up.io/api/get-poi', { params: {
                    filters: this.filters,
                    bounds: this.getBounds()
                
                } })
                .then(function (response) {
                    response.data.slice(0, 50).forEach(function(poi) {
                        //console.log(poi)
                        self.markers.push({
                            position: {
                                lat: parseFloat(poi.lat),
                                lng: parseFloat(poi.lon)
                            },
                            icon: '/img/pin-theme' + poi.id_theme_1 + '.svg',
                            infos: {
                                cat: poi.theme_2,
                                nom: poi.nom || poi.theme_2
                            }
                        })
                    })
                });
        },
    },
    mounted() {
        this.$refs.mapRef.$mapPromise.then((map) => {
            //console.log(map)
            //map.panTo({lat: 1.38, lng: 103.80})
          })

    },
};
</script>
